define([
	"csi/def/ActionFactory",
	"./_MoveUpDown"
], function(ActionFactory,_MoveUpDown) {

	return ActionFactory.declare("MoveDown", _MoveUpDown, {
		m_tag: "MoveDown"
	});
});